import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const ElementSettingsSchedulerDesign = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const element = builder.selected().object;
  const variant = contextData.objects.variant;

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Scheduler" open={false}>
        <VariantBuilderSetting
          object={element}
          setting_name="[options][scheduler-max-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Max Width"
          value={element.options["scheduler-max-width"]}
          placeholder={variant.options["scheduler-max-width"] || "auto"}
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][scheduler-max-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Max Width"
          value={element.options["scheduler-max-width-mobile"]}
          placeholder={
            variant.options["scheduler-max-width-mobile"] ||
            variant.options["scheduler-max-width"] ||
            "auto"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][scheduler-min-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Min Height"
          value={element.options["scheduler-min-height"]}
          placeholder={variant.options["scheduler-min-height"] || "700"}
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="desktop"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][scheduler-min-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Min Height"
          value={element.options["scheduler-min-height-mobile"]}
          placeholder={
            variant.options["scheduler-min-height-mobile"] ||
            variant.options["scheduler-min-height"] ||
            "700"
          }
          min={0}
          max={2560}
          range_step="1"
          allow_empty={true}
          device="mobile"
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Border" open={false}>
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Border Style"
          setting_name="[options][scheduler-border-style]"
          setting_type="border_style"
          value={element.options["scheduler-border-style"]}
          placeholder={variant.options["scheduler-border-style"] || "none"}
          show_reset={true}
        />

        {element.options["scheduler-border-style"] &&
          element.options["scheduler-border-style"] !== "none" && (
            <div
              className="col-xs-12 some-vertical-space setting"
              style={{ marginBottom: "5px" }}
            >
              <div className="row">
                <div className="col-xs-12">
                  <div className="mb-[5px] text-xl text-black dark:text-white">
                    Border Width
                  </div>

                  {["left", "top", "bottom", "right"].map((side) => {
                    const settingName = `[options][scheduler-border-width-${side}]`;
                    return (
                      <VariantBuilderSetting
                        key={settingName}
                        object={element}
                        object_type="elements"
                        object_id={element.id}
                        setting_name={settingName}
                        setting_type="number"
                        value={
                          element.options[`scheduler-border-width-${side}`]
                        }
                        placeholder={
                          element.options["scheduler-border-width"] || "1"
                        }
                        col="3"
                        note={window.capitalizeFirstLetter(side)}
                        classNames="spacing-inputs"
                        min={0}
                        allow_empty={true}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          )}

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Border Color"
          setting_name="[options][scheduler-border-color]"
          setting_type="color_v2"
          placeholder={variant.options["scheduler-border-color"] || "#000"}
          value={
            element.options["scheduler-border-color"]
              ? element.options["scheduler-border-color"]
              : undefined
          }
          show_reset={true}
          condition={
            element.options["scheduler-border-style"] &&
            element.options["scheduler-border-style"] !== "none"
          }
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Border Radius"
          setting_name="[options][scheduler-border-radius]"
          setting_type="range"
          value={element.options["scheduler-border-radius"]}
          placeholder={variant.options["scheduler-border-radius"] || "0"}
          min={0}
          max={100}
          range_step="1"
          allow_empty={true}
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default ElementSettingsSchedulerDesign;
